import { useState, useEffect, useMemo } from 'react'

import { OurHistory } from '@/service/api/culturePage/types'
import { useScreen } from '@/store/screen'

export const useOurHistory = (props: { data: OurHistory }) => {
  const { data } = props

  const { windowSize, isSmallDesktop } = useScreen()

  const fontSizeByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h3' as const,
        contentTitle: 'h5' as const,
        contentDescription: 'b3' as const,
      },
      861: {
        title: 'h3' as const,
        contentTitle: 'b1' as const,
        contentDescription: 'b3' as const,
      },
      670: {
        title: 'h5' as const,
        contentTitle: 'b3' as const,
        contentDescription: 'b2' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSize = useMemo(() => {
    if (!width) return fontSizeByScreenSize[1440]
    if (width <= 670) return fontSizeByScreenSize[670]
    if (width <= 861) return fontSizeByScreenSize[861]
    return fontSizeByScreenSize[1440]
  }, [width, fontSizeByScreenSize])

  const timelineKeys = useMemo(
    () => Object.keys(data.timeline),
    [data.timeline],
  )

  const [selectedYear, setSelectedYear] = useState(timelineKeys[0])

  useEffect(() => {
    const firstKey = timelineKeys[0]
    setSelectedYear(firstKey)
  }, [timelineKeys])

  const checkIfColored = (currentYear: number, year: number) =>
    currentYear >= year

  const handleTimelinePointClick = (year: string) => {
    setSelectedYear(year)
  }

  const handleYearAndTimeline = (next: boolean, year: string) => {
    const currentYear = timelineKeys.findIndex((index) => index === year)
    const numberYear = Number(year)
    const nextYear = next
      ? Number(timelineKeys[currentYear + 1]) - numberYear
      : Number(timelineKeys[currentYear - 1]) - numberYear
    const updatedYear = String(numberYear + nextYear)
    setSelectedYear(updatedYear)
  }
  const handleNextYear = (year: string) => {
    const lastYear = timelineKeys.at(-1)
    if (year === lastYear) return
    handleYearAndTimeline(true, year)
  }

  const handlePreviousYear = (year: string) => {
    const firstYear = timelineKeys[0]
    if (year === firstYear) return
    handleYearAndTimeline(false, year)
  }

  const responsive = {
    desktop: {
      breakpoint: { max: 2500, min: 768 },
      items: 3,
    },
  }
  return {
    selectedYear,
    checkIfColored,
    handleTimelinePointClick,
    handleNextYear,
    handlePreviousYear,
    isSmallDesktop,
    fontSize,
    responsive,
    timelineKeys,
  }
}
